import {Container} from "../Core/Container";
import {Sprite} from "../Core/Sprite";
import {Button} from "./Button";
import {PackageModel} from "../Data/ItemModel";
import {textureOrDefault} from "../Core/AssetHelpers";
import {Mix} from "../Core/Reflection";
import {TransformBackup} from "../Core/TransformBackup";
import {playVO, PostcardVO, voOptionsRepeat} from "../Data/VoiceOver";

export class Postcard extends Mix(Container, TransformBackup) {

    public readonly background = this.addChild(new Sprite());
    public readonly image = this.addChild(new Sprite());
    public readonly title = this.addChild(new Sprite());
    public readonly buttonSpeaker = this.addChild(new Button());

    setModel(model: PackageModel) {
        this.image.texture = textureOrDefault(`card-image-${model.country}-${model.itemType}`, `card-image-${model.country}`);
        this.title.texture = textureOrDefault(`card-title-${model.country}-${model.itemType}`, `card-title-${model.country}`);
        this.image.scale.set(2);
        this.title.scale.set(2);

        this.buttonSpeaker.hoverVO = "LetsGoLuna_017";
        this.buttonSpeaker.onClick.remove();
        this.buttonSpeaker.onClick.add(() => {
            const vo = PostcardVO(model);
            if (vo) {
                playVO(vo, voOptionsRepeat);
            }
        });
    }
}